import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DateRangeType } from '@features/dashboard/types';

interface LeadListState {
  currentPage: number;
  search: string;
  selectedSources: string[];
  selectedStatusIds: string[];
  selectedTagIds: string[];
  selectedAssigneeIds: string[];
  dateRangeType: string;
  selectedDateRange: DateRangeType;
}

const initialState: LeadListState = {
  currentPage: 0,
  search: '',
  selectedSources: [],
  selectedStatusIds: [],
  selectedTagIds: [],
  selectedAssigneeIds: [],
  dateRangeType: '',
  selectedDateRange: {
    startDate: '',
    endDate: ''
  }
};

export const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    setLeadListPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setLeadSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setLeadSelectedSources: (state, action: PayloadAction<string[]>) => {
      state.selectedSources = action.payload;
    },
    setLeadSelectedStatusIds: (state, action: PayloadAction<string[]>) => {
      state.selectedStatusIds = action.payload;
    },
    setLeadSelectedTagIds: (state, action: PayloadAction<string[]>) => {
      state.selectedTagIds = action.payload;
    },
    setLeadSelectedAssigneeIds: (state, action: PayloadAction<string[]>) => {
      state.selectedAssigneeIds = action.payload;
    },
    setLeadDateRangeType: (state, action: PayloadAction<string>) => {
      state.dateRangeType = action.payload;
    },
    setLeadDateRange: (state, action: PayloadAction<DateRangeType>) => {
      state.selectedDateRange = action.payload;
    },
    resetLeadListPage: () => initialState
  }
});

export const {
  setLeadListPage,
  setLeadSearch,
  setLeadSelectedSources,
  setLeadSelectedStatusIds,
  setLeadSelectedTagIds,
  setLeadSelectedAssigneeIds,
  setLeadDateRangeType,
  setLeadDateRange,
  resetLeadListPage
} = leadSlice.actions;
export default leadSlice.reducer;
